// extracted by mini-css-extract-plugin
module.exports = {"list":"services-list-module--list--2vdfF","item":"services-list-module--item--3PKyz"};